<h1>Genuary 2023</h1>
<p>
  A few <a href="genuary/">Genuary 2023</a> experiments.
</p>
<a href="genuary/">
  <img
    src="../genuary/img/07/1.png"
    alt="genuary7 by Pandelune"
  />
</a>
<p></p>
<a href="genuary/">
  <img
    src="../genuary/img/14/4.png"
    alt="genuary14 by Pandelune"
  />
</a>
